import api from "../../app/api";
import { withNormalizedCurrency } from "../../utils/helpers";

export const getMerchant = async (userId) => {
  const { data } = await api.get(`merchant/user/${userId}`);
  return data;
};

export const fetchBankAccounts = async ({ userId }) => {
  const { data } = await api.get(`merchant/bankaccount/user/${userId}`);
  return data;
};

export async function createUpdateBankAccount(payload) {
  const { data } = await api.post(
    "merchant/bankaccount/",
    withNormalizedCurrency(payload),
  );
  return data;
}

export async function updateBankAccountById({bankAccountId, payload}) {
  const { data } = await api.put(
    `merchant/bankaccount/${bankAccountId}`,
    withNormalizedCurrency(payload),
  );
  return data;
}

export async function createUpdateBusiness(payload) {
  const { data } = await api.post("merchant/business/", payload);
  return data;
}

export async function getBusinessTypes() {
  const { data } = await api.get("merchant/businesstype");
  return data;
}

export async function getBusinessCategories() {
  const { data } = await api.get("merchant/businesscategory");
  return data;
}

export async function getBusinessContacts(businessId) {
  const { data } = await api.get(
    `merchant/businessstaff/${businessId}/business`,
  );
  return data;
}

export async function createUpdateBusinessContacts(payload) {
  const { data } = await api.post("merchant/businessstaff/", payload);
  return data;
}

export async function getContactRoles() {
  const { data } = await api.get("merchant/businessstaffrole");
  return data;
}

export async function getBusinessKeys(businessId) {
  const { data } = await api.get(`merchant/v2/business/${businessId}/keys`);
  return data;
}

export async function getBusinessWallet(businessId) {
  const { data } = await api.get(`wallet/business/${businessId}/all`);
  return data;
}

export async function createBusinessPaymentOption(payload) {
  const { data } = await api.post(
    "/merchant/business/payment/options",
    payload,
  );
  return data;
}

export async function getBusinessPaymentOptions(payload) {
  const { data } = await api.post("merchant/merchantexchange", payload);
  return data;
}

export async function deletePaymentOptionById({
  businessId,
  paymentOptionId,
}: {
  businessId: number;
  paymentOptionId: number;
}) {
  const { data } = await api.get(
    `/merchant/business/payment/options/delete/${paymentOptionId}/${businessId}`,
  );
  return data;
}

export async function getAllPaymentOptions() {
  const { data } = await api.get("/merchant/payment/options");
  return data;
}

export const getBankList = async (countryCode: string) => {
  const { data } = await api.get(
    `/wallet/merchant/bank/transfer/request/banks/${countryCode}`,
  );
  return data?.data ?? data;
};

export const getAccountName = async (
  accountNumber: string,
  bankCode: string,
  countryCode = "NG",
) => {
  const { data } = await api.post(
    `/wallet/merchant/bank/transfer/request/resolve/account`,
    {
      accountNumber,
      bankCode,
      countryCode,
    },
  );
  return data;
};

export const createWebHook = async (data) => {
  const response = await api.post(`/merchant/businesswebhook`, data);
  return response.data;
};

const buildCustomizationFormData = (
  customization: Record<string, unknown>,
  logo?: File | null,
) => {
  const formData = new FormData();
  Object.entries(customization).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      formData.append(key, String(value));
    }
  });
  if (logo) {
    formData.append("logo", logo);
  }
  return formData;
};

export const CreateBusinessLogo = async (
  customization: Record<string, unknown>,
  logo: File,
) => {
  const response = await api.post(
    `/merchant/customization/v2`,
    buildCustomizationFormData(customization, logo),
  );
  return response.data;
};

export const UpdateMerchantBusinessLogo = async (
  customization: Record<string, unknown>,
  logo?: File | null,
) => {
  const response = await api.patch(
    `/merchant/customization/v2`,
    buildCustomizationFormData(customization, logo),
  );
  return response.data;
};

export const GetMerchantBusinessLogo = async (businessId) => {
  const response = await api.get(
    `/merchant/customization/${businessId}?type=EMAIL`,
  );
  return response.data;
};

export const saveEmailBusinessLogo = async (businessId, logo: File) => {
  let existingCustomizationId;
  try {
    const existing = await GetMerchantBusinessLogo(businessId);
    existingCustomizationId = existing?.data?.id;
  } catch (error) {
    existingCustomizationId = undefined;
  }

  const customization = { businessId, customizationPage: "EMAIL" };
  return existingCustomizationId
    ? UpdateMerchantBusinessLogo({ ...customization, id: existingCustomizationId }, logo)
    : CreateBusinessLogo(customization, logo);
};

export const getBusinessWebHook = async ({ id }) => {
  const response = await api.get(`/merchant/businesswebhook/business/${id}`);
  return response.data;
};

export const UpdateMerchantDetails = async (data, id) => {
  const response = await api.patch(`/merchant/business/${id}/update`, data);
  return response.data;
};
